import { XmlSchemaFacet } from './XmlSchemaFacet';

export abstract class XmlSchemaNumericFacet extends XmlSchemaFacet {}
